import * as motion from "motion/react-client";
import { MouseEvent } from "react";

export const ButtonPill = ({
  backgroundColor,
  textColor,
  text,
  width,
  style,
  onClick,
}: {
  backgroundColor: string;
  textColor: string;
  text: string;
  width?: number | string;
  style?: React.CSSProperties;
  onClick: (e?: MouseEvent) => any;
}) => {
  const stopProp = (e: MouseEvent) => {
    e.stopPropagation();
    onClick(e);
  }
  const s = width ? { width } : {};
  return (
    <motion.div
      onClick={stopProp}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      style={{
        backgroundColor,
        color: textColor,
        borderRadius: 16,
        paddingLeft: ".5rem",
        paddingRight: ".5rem",
        ...s,
        ...style,
      }}
    >
      {text}
    </motion.div>
  );
};
